import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseInfoOnOrderAdapter = getAdapter();

const warehouseInfoOnOrderSlice = createSlice({
  name: 'warehouseInfoOnOrder',
  initialState: warehouseInfoOnOrderAdapter.getInitialState(),
  reducers: {
    setWarehouseInfoOnOrder: (state, { payload: { warehouseInfoOnOrder } }) => {
      warehouseInfoOnOrderAdapter.setOne(state, warehouseInfoOnOrder);
    }
  }
});

const selectors = warehouseInfoOnOrderAdapter.getSelectors(({ warehouseInfoOnOrder }) => warehouseInfoOnOrder);

export const getWarehouseInfoOnOrder = state => selectors.selectAll(state)[0];

export const {
  setWarehouseInfoOnOrder
} = warehouseInfoOnOrderSlice.actions;

export default warehouseInfoOnOrderSlice.reducer;